import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const WarningFill16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M6.1677 2.58351C6.982 1.13883 9.01844 1.13883 9.83274 2.58351L14.714 11.2504C15.5272 12.6949 14.5093 14.5 12.882 14.5H3.11842C1.4908 14.5 0.472243 12.6952 1.28646 11.2504L6.1677 2.58351ZM7.3 4.98214C7.3 4.59752 7.6134 4.28571 8 4.28571C8.3866 4.28571 8.7 4.59752 8.7 4.98214V9.16071C8.7 9.54534 8.3866 9.85714 8 9.85714C7.6134 9.85714 7.3 9.54534 7.3 9.16071V4.98214ZM7.06667 11.7143C7.06667 11.2014 7.48453 10.7857 8 10.7857C8.51547 10.7857 8.93333 11.2014 8.93333 11.7143C8.93333 12.2271 8.51547 12.6429 8 12.6429C7.48453 12.6429 7.06667 12.2271 7.06667 11.7143Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
